/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Slovak
export default {
	'fabric.linking.accounts': 'Účty',
	'fabric.linking.actions': 'Akcie',
	'fabric.linking.add_account': 'Pridať účet',
	'fabric.linking.annotate': 'Komentovať',
	'fabric.linking.annotate.confirmation.close.anyway': 'Aj tak zatvoriť',
	'fabric.linking.annotate.confirmation.content': 'Máte neuložené zmeny. Naozaj chcete odísť?',
	'fabric.linking.annotate.confirmation.heading': 'Neuložené zmeny',
	'fabric.linking.annotate.tool.arrow': 'Šípka',
	'fabric.linking.annotate.tool.blur': 'Rozmazanie',
	'fabric.linking.annotate.tool.brush': 'Štetec',
	'fabric.linking.annotate.tool.color': 'Farba',
	'fabric.linking.annotate.tool.line.thickness': 'Hrúbka čiary',
	'fabric.linking.annotate.tool.shape': 'Tvar',
	'fabric.linking.annotate.tool.text': 'Text',
	'fabric.linking.audio': 'zvuk',
	'fabric.linking.cancel': 'Zrušiť',
	'fabric.linking.cant_preview_file_type': 'Nemôžeme zobraziť náhľad tohto typu súboru.',
	'fabric.linking.cant_retrieve_files': 'Ejha! Nepodarilo sa nám načítať žiadne súbory.',
	'fabric.linking.cant_retrieve_gifs': 'Ach nie! Nepodarilo sa nám získať žiadne obrázky GIF',
	'fabric.linking.check_your_network': 'Skontrolujte sieťové pripojenie',
	'fabric.linking.close': 'Zatvoriť',
	'fabric.linking.connect_account_description':
		'Otvoríme novú stránku, aby sme vám pomohli pri pripojení k vášmu účtu {name}',
	'fabric.linking.connect_link_account': 'Ak chcete zobraziť náhľad, pripojte svoj účet',
	'fabric.linking.connect_link_account_card_view': 'Pripojiť',
	'fabric.linking.connect_link_account_card_view_name': 'Pripojte svoj účet {context}',
	'fabric.linking.connect_to': 'Pripojiť k {name}',
	'fabric.linking.could_not_load_editor': 'Ľutujeme, nepodarilo sa načítať editor',
	'fabric.linking.could_not_save_image': 'Ľutujeme, nepodarilo sa uložiť obrázok',
	'fabric.linking.couldnt_generate_preview': 'Nepodarilo sa vytvoriť náhľad tohto súboru.',
	'fabric.linking.default_avatars': 'Predvolené avatary',
	'fabric.linking.disable_fullscreen': 'deaktivovať zobrazenie na celú obrazovku',
	'fabric.linking.document': 'dokument',
	'fabric.linking.download': 'Prevziať',
	'fabric.linking.drag_and_drop_images_here': 'Sem myšou presuňte obrázky',
	'fabric.linking.drag_and_drop_your_files': 'Kdekoľvek potiahnite a pustite súbory alebo',
	'fabric.linking.drop_your_files': 'Pustite súbory na nahranie',
	'fabric.linking.drop_your_files_here': 'Sem presuňte súbory',
	'fabric.linking.enable_fullscreen': 'povoliť zobrazenie na celú obrazovku',
	'fabric.linking.error_generating_preview': 'Pri vytváraní náhľadu sa vyskytla chyba',
	'fabric.linking.error_hint_critical': 'Ak problém pretrváva, obráťte sa na podporu.',
	'fabric.linking.error_hint_retry': 'Skúste to znova a my tomu dáme druhú šancu.',
	'fabric.linking.error_loading_file': 'Pri načítaní súboru sa vyskytla chyba',
	'fabric.linking.failed_to_load': 'Nahratie zlyhalo',
	'fabric.linking.give_feedback': 'Poskytnúť spätnú väzbu',
	'fabric.linking.image': 'obrázok',
	'fabric.linking.image_format_invalid_error': 'Nepodarilo sa načítať obrázok, formát je neplatný.',
	'fabric.linking.image_size_too_large_error':
		'Obrázok je príliš veľký, nesmie byť väčší ako {MAX_SIZE_MB} Mb',
	'fabric.linking.image_url_invalid_error':
		'Nepodarilo sa načítať obrázok, adresa url je neplatná.',
	'fabric.linking.insert_files':
		'{0, plural, one {Vložiť {0} súbor} few {Vložiť {0} súbory} many {Vložiť {0} súboru} other {Vložiť {0} súborov}}',
	'fabric.linking.invalid_permissions_description':
		'Ak si chcete zobraziť tento náhľad, požiadajte o prístup alebo vyskúšajte iný účet.',
	'fabric.linking.item_not_found_in_list': 'Vybraná položka sa nenašla v zozname.',
	'fabric.linking.learn_more': 'Ďalšie informácie',
	'fabric.linking.load_more_gifs': 'Načítať viac obrázkov GIF',
	'fabric.linking.loading': 'Načítava sa...',
	'fabric.linking.might_be_a_hiccup': 'Môže to byť len nejaký nepodstatný problém.',
	'fabric.linking.no_gifs_found': 'Dobrý deň? Poviete nám, čo hľadáte?',
	'fabric.linking.no_gifs_found_suggestion': 'Nič sa nám nepodarilo nájsť pre "{query}"',
	'fabric.linking.no_pdf_artifacts': 'Pre tento súbor sa nenašli žiadne časti PDF.',
	'fabric.linking.not_found_title': 'Ejha. Toto prepojenie sa nepodarilo nájsť.',
	'fabric.linking.or': 'alebo',
	'fabric.linking.recent_uploads': 'Posledné nahrania',
	'fabric.linking.remove_image': 'Odstrániť obrázok',
	'fabric.linking.retry': 'Opakovať',
	'fabric.linking.save': 'Uložiť',
	'fabric.linking.search_all_gifs': 'Prehľadať všetky obrázky GIF!',
	'fabric.linking.share_files_instantly': 'Okamžite ich začneme zdieľať',
	'fabric.linking.something_went_wrong': 'Vyskytol sa problém.',
	'fabric.linking.srclink': 'Zobraziť v:',
	'fabric.linking.srclinkunknown': 'Zobraziť originál',
	'fabric.linking.try_again': 'Skúste to znova',
	'fabric.linking.try_another_account': 'Vyskúšajte iný účet',
	'fabric.linking.try_downloading_file': 'Skúste prevziať tento súbor na jeho zobrazenie.',
	'fabric.linking.unable_to_annotate_image': 'Nemôžete komentovať tento obrázok',
	'fabric.linking.unknown': 'neznáme',
	'fabric.linking.unlink_account': 'Zrušiť prepojenie účtu',
	'fabric.linking.upload': 'Nahrať',
	'fabric.linking.upload_an_avatar': 'Nahrať avatara',
	'fabric.linking.upload_file': 'Nahrať súbor',
	'fabric.linking.upload_file_from': 'Nahrať súbor z {name}',
	'fabric.linking.upload_image': 'Nahrať  obrázok',
	'fabric.linking.upload_photo': 'Nahrať fotografiu',
	'fabric.linking.video': 'video',
	'fabric.linking.webgl_warning_description':
		'Váš prehliadač nepodporuje knižnicu WebGL. Ak chcete komentovať obrázky, použite prehliadač s povolenou knižnicou WebGL.',
	'fabric.linking.zoom_in': 'priblížiť',
	'fabric.linking.zoom_out': 'oddialiť',
};
